import { DashboardModuleListItem, SidebarModalListItem, Text } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/useProviderPackageItem'

import { ProviderPackageItemModel } from '@models/types'

interface ProviderPackageItemListItemProps {
  providerPackageItem: ProviderPackageItemModel,
}

const ProviderPackageItemListItem = (props: ProviderPackageItemListItemProps) => {
  const {
    providerPackageItem, providerPackageItem: {
      id, options_string, price, quantity, title: itemTitle,
    },
  } = props

  const { providerPriceList: { title } } = useRelations(providerPackageItem)

  return (
    <SidebarModalListItem
      // @ts-expect-error TS2322
      forceBottomBorder
      secondaryText={(<Text variant="ellipsis">${price} {title}</Text>)}
      title={`${quantity} x ${itemTitle} ${options_string}`}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </SidebarModalListItem>
  )
}

export default ProviderPackageItemListItem
